import CreationToolOutputType from '../types/output-type'
import CreationToolStep from '../types/steps'
import getSourceInfo from './get-source-info'

/**
 * Returns an array of creation steps based on the file added and output type.
 * @param {File|string} source Source file object or url
 * @param {string} outputType Current creation output type (gif, sticker, video, etc.)
 * @returns {object[]}
 */
const getCreationSteps = (source: File | string, outputType: CreationToolOutputType): CreationToolStep[] => {
    const steps: CreationToolStep[] = []
    const { isVideo, isAnimated } = getSourceInfo(source)

    // if this is a video, first go to trim
    if (isVideo) {
        steps.push(CreationToolStep.VideoTrim)
    }

    // if output type is a sticker, go to cut out phase
    if (outputType === CreationToolOutputType.Sticker) {
        steps.push(CreationToolStep.CutOut)

        // if source file is a still image, go to animate phase
        if (!isAnimated) {
            steps.push(CreationToolStep.Animate)
        }

        steps.push(CreationToolStep.Upload)
    } else {
        steps.push(CreationToolStep.Decorate)
    }

    return steps
}

export default getCreationSteps
